import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowAlignHorizontalCentre32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconArrowAlignHorizontalCentre32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16 3a1 1 0 0 1 1 1v5.821l2.528-2.528a1 1 0 1 1 1.414 1.414L16.7 12.95l-.707.707-.707-.707-4.243-4.243a1 1 0 0 1 1.414-1.414L15 9.836V4a1 1 0 0 1 1-1M6 16a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1m9 6.164-2.543 2.543a1 1 0 0 1-1.414-1.414l4.243-4.243.707-.707.707.707 4.243 4.243a1 1 0 0 1-1.415 1.414L17 22.18V28a1 1 0 1 1-2 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowAlignHorizontalCentre32);
